import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import '@stoplight/elements-core/styles.min.css'

import './index.css'
import App from './App'

window.API_VERSION = process.env.REACT_APP_VERSION || '';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
)
